module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/m3-764f590787b7e27a5afce78ea92c3d67.svg";